export enum STAGED_UPLOAD_RESOURCES {
    productImage = 'PRODUCT_IMAGE',
}
export enum FILE_CREATE_CONTENT_TYPE {
    image = 'IMAGE',
}
